import type { DateTime, Interval } from 'luxon';

// Interval.contains exludes the end date https://github.com/moment/luxon/issues/1105
// We want to include the end date, so we manually compare against the start/end of the interval.
// You can compare DateTime objects directly https://moment.github.io/luxon/#/math?id=comparing-datetimes
export function intervalContainsInclusive(dateRange: Interval, date: DateTime) {
  return dateRange.start && dateRange.start <= date && dateRange.end && dateRange.end >= date;
}

export function intervalContainsInclusiveISO(
  start: string | undefined,
  end: string | undefined,
  date: string,
): boolean {
  return !!(start && start <= date && end && end >= date);
}
